import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HttpService from '../../Services/environment';
import { CustomPagination } from '../../UIComponents/CustomPagination';
import { getCurrentUser } from '../../Services/httpCalls';
import useRequestContext from '../../context/requestContext';

const RequestHistory = () => {
  const navigate = useNavigate();
  const { request } = useRequestContext();
  const requestId = request?.[0]?.id;
  const [history, setHistory] = useState({ data: { history: [] } });
  const [offset, setOffset] = useState(0);
  const LIMIT = 5;
  const [currentPage, setCurrentPage] = useState(0);
  const [userComments, setUserComments] = useState(null);

  const pageCount = useMemo(() => {
    return Math.ceil(history?.data?.history.length / LIMIT);
  }, [history]);

  const getUserComments = async () => {
    try {
      const res = await getCurrentUser();
      setUserComments(res?.data?.user?.comments ?? null);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const getHistory = async () => {
      const resp = await HttpService.getAxiosClient().get(
        `requests/${requestId}/history`,
      );
      setHistory(resp);
    };

    if (requestId) {
      getHistory();
    }

    getUserComments();
  }, [requestId]);

  const initialRequestData = request[0]
    ? {
        id: request[0]?.id,
        request_id: request[0]?.id,
        el_date: request[0]?.creation_date,
      }
    : null;

  const userHasComment = userComments !== null;

  return (
    <>
      <Box>
        <Typography sx={{ my: 4, fontSize: '30px' }}>Η θυρίδα μου</Typography>
        <Typography variant="h1">Ιστορικό</Typography>
        <Typography sx={{ my: 4 }}>
          Η θυρίδα σας περιέχει το ιστορικό των αλλαγών που έχετε
          πραγματοποιήσει
        </Typography>
        <Typography sx={{ my: 4 }}>
          {`Εμφανίζονται `}
          <strong>
            {history?.data?.history.length + (initialRequestData ? 1 : 0)}
          </strong>
          {` αποτελέσματα`}
        </Typography>

        <Box>
          {history?.data?.history && (
            <DataGrid
              suppressColumnVirtualisation={true}
              suppressRowVirtualisation={true}
              role="grid"
              id="grid"
              aria-colcount="1"
              aria-rowcount={history?.data?.history.length}
              aria-multiselectable="false"
              aria-label="Πίνακας Ιστορικού"
              initialState={{
                pagination: {
                  paginationModel: { pageSize: LIMIT, page: 0 },
                },
              }}
              pageSizeOptions={[5, 10, 25]}
              pagination
              pageSize={5}
              slots={{ pagination: CustomPagination }}
              slotProps={{
                pagination: {
                  totalCount: history?.data?.history.length,
                  setOffset: setOffset,
                  limit: LIMIT,
                  pageCount: pageCount,
                  setCurrentPage: setCurrentPage,
                  currentPage: currentPage,
                },
              }}
              disableRowSelectionOnClick
              columnHeaderHeight={1}
              sx={{
                '&, [class^=MuiDataGrid]': {
                  border: 'none',
                  overflow: 'hidden',
                  justifyContent: 'flex-start',
                },
              }}
              rows={[
                ...(history?.data?.history || []),
                ...(initialRequestData ? [initialRequestData] : []),
                ...(userHasComment
                  ? [
                      {
                        id: 10000,
                        request_id: request[0].id,
                        changes: 'Διαγραφή χρήστη',
                        creation_date: '',
                        en_date: '',
                        el_date: '',
                      },
                    ]
                  : []),
              ]}
              columns={[
                {
                  field: 'request',
                  flex: 1,
                  headerName: '',
                  renderCell: (params) => (
                    <Box
                      sx={{
                        borderBottom: '1px solid',
                        borderColor: 'gray.light',
                        width: '100%',
                      }}
                    >
                      <Typography
                        sx={{
                          color: 'black.main',
                          px: 0.5,
                        }}
                      >
                        {params.row.changes === 'Διαγραφή χρήστη'
                          ? `${userComments}`
                          : params.row.changes
                            ? 'Μεταβολή αίτησης στο μητρώο απασχολούμενων του πολιτιστικού και δημιουργικού τομέα'
                            : 'Αίτηση - Εγγραφή στο μητρώο απασχολούμενων του πολιτιστικού και δημιουργικού τομέα'}
                      </Typography>
                      <Typography sx={{ color: 'gray.main' }}>
                        {`${params.row.el_date} ${params.row.changes || ''}`}
                      </Typography>
                    </Box>
                  ),
                },
              ]}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default RequestHistory;
